// Action types for spot
const TOGGLE_SPOT_MODAL = 'TOGGLE_SPOT_MODAL';
const SET_PANEL_MODE = 'SET_PANEL_MODE';
const SET_CAME_FROM_TRADE = 'SET_CAME_FROM_TRADE';
const SET_ASSET_CHANGE_DISABLED = 'SET_ASSET_CHANGE_DISABLED';
const SET_TRANSFER_AMOUNT = 'SET_TRANSFER_AMOUNT';

export {
  TOGGLE_SPOT_MODAL,
  SET_PANEL_MODE,
  SET_CAME_FROM_TRADE,
  SET_ASSET_CHANGE_DISABLED,
  SET_TRANSFER_AMOUNT,
};
